module.exports = {
    languageData: () => {
      return{
        "en": {
          "metahuman_name": "Rem from Holidate",
          "loading": "LOADING",
          "message": "Message",
          "free": "Free",
          "press_to_continue": "CLIC OR TAP TO CONTINUE",
          "press_to_stop": "Press the stop button to finish",
          "press_to_record": "Press the mic to record a message",
        },
        "es": {
          "metahuman_name": "Rem de Holidate",
          "loading": "LOADING",
          "message": "Mensaje",
          "free": "Gratis",
          "press_to_continue": "PRESIONE PARA CONTINUAR",
          "press_to_stop": "Presione el botón detener para finalizar",
          "press_to_record": "Presione el micrófono para grabar un mensaje",
        }
      }
    }
  }